/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['app-root{display:block;transition:opacity .4s cubic-bezier(.25,.8,.25,1)}app-root.loading{opacity:.7}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovd2FtcDY0L3d3dy9oZWxwZGVzay9jbGllbnQvc3JjL2FwcC9hcHAuY29tcG9uZW50LnNjc3MubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0U6L3dhbXA2NC93d3cvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvYXBwLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// E:/wamp64/www/helpdesk/client/src/$$_gendir/app/app.component.scss.ngstyle.ts